import { HolderOutlined } from '@ant-design/icons';
import { DraggableProvidedDragHandleProps } from 'react-beautiful-dnd';

interface DragHandleProps {
  dragHandleProps?: DraggableProvidedDragHandleProps | null;
  size?: 'small' | 'medium' | 'large';
}

export function DragHandle({ dragHandleProps, size = 'medium' }: DragHandleProps) {
  const sizeClasses = {
    small: 'text-base',
    medium: 'text-lg',
    large: 'text-xl',
  };

  return (
    <div {...(dragHandleProps || {})} className="cursor-move">
      <HolderOutlined className={`text-gray-400 ${sizeClasses[size]}`} />
    </div>
  );
}
